<!-- *************************************************************************
	TEMPLATE
	************************************************************************* -->
<template>
  <div>
    <PageTitle
      title="Customer View"
      :backBtn="true"
      :editRoute="'/customer/edit/' + this.$route.params.id"
      :permission="'Customer Edit'"
    />
    <v-container fluid class="lighten-12 container">
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="4">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-account-convert</v-icon>
                  <span class="pl-3">Customer Details</span></v-card-title
                >
                <v-container
                  fluid
                  class="container saledetailscard"
                  style="padding: 0px"
                >
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row class="pt-0">
                        <v-col
                          cols="12"
                          sm="12"
                          md="9"
                          lg="9"
                          class="pr-5pt-1.5 pb-1 reference_number"
                        >
                          <span>{{ this.name }}</span>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3" class="shoptext">
                          <v-row>
                            <v-chip
                              style="
                                color: white;
                                font-variant-caps: all-small-caps;
                                font-weight: bold;
                              "
                              text-color="white"
                              :color="getStatusColor(this.status)"
                              dark
                              label
                              >{{ this.status ? 'Active' : 'Archived' }}</v-chip
                            >
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Ref Number </v-row>
                          <v-row>
                            {{ this.reference_number }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Customer Type </v-row>
                          <v-row>
                            <v-chip
                              style="
                                color: white;
                                font-variant-caps: all-small-caps;
                                font-weight: bold;
                              "
                              text-color="white"
                              :color="getSaleTypeColor(this.customerType)"
                              dark
                              label
                              >{{ this.customerType }}</v-chip
                            >
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="subtextlable"
                        >
                          <v-row> Total Sales Amount </v-row>
                          <v-row>
                            <v-chip
                              label
                              text-color="white"
                              style="font-weight: bold"
                              color="primary"
                              dark
                              >LKR
                              {{ this.grand_total | formatCurrency }}</v-chip
                            >
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="subtextlable"
                        >
                          <v-row> Total Sales Due Amount </v-row>
                          <v-row>
                            <v-chip
                              label
                              text-color="white"
                              style="font-weight: bold"
                              color="red"
                              dark
                              >LKR
                              {{
                                (this.grand_total - this.paid_amount)
                                  | formatCurrency
                              }}</v-chip
                            >
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="4">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-city</v-icon
                  ><span class="pl-3"> Address</span>
                </v-card-title>
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                      class="pt-0"
                      v-for="item in addresses"
                      :key="item.message"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Address Line 1 </v-row>
                          <v-row style="text-align: left">
                            {{
                              item.address_line1 ? item.address_line1 : '---'
                            }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Address Line 2 </v-row>
                          <v-row style="text-align: left">
                            {{
                              item.address_line2 ? item.address_line2 : '---'
                            }}
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> City </v-row>
                          <v-row style="text-align: left">
                            {{ item.city ? item.city : '---' }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Postal Code </v-row>
                          <v-row style="text-align: left">
                            {{ item.postal_code ? item.postal_code : '---' }}
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Country </v-row>
                          <v-row style="text-align: left">
                            {{ item.country ? item.country.name : '---' }}
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-if="addresses.length == 0">
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <div class="mt-16 container justify-center item-center">
                        <img
                          style="height: 50px"
                          src="../../../assets/img/01.gif"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-phone</v-icon
                  ><span class="pl-3"> Contact</span>
                </v-card-title>
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                      class="pt-0"
                      v-for="item in contacts"
                      :key="item.message"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Full Name </v-row>
                          <v-row style="text-align: left">
                            {{ item.full_name ? item.full_name : '---' }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Telephone </v-row>
                          <v-row style="text-align: left">
                            <a
                              href=""
                              :style="
                                item.telephone && item.telephone
                                  ? { color: 'blue' }
                                  : { 'text-decoration': 'none' }
                              "
                            >
                              {{ item.telephone ? item.telephone : '---' }}
                            </a>
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Phone </v-row>
                          <v-row style="text-align: left">
                            <a
                              href=""
                              :style="
                                item.phone && item.phone
                                  ? { color: 'blue' }
                                  : { 'text-decoration': 'none' }
                              "
                            >
                              {{ item.phone ? item.phone : '---' }}
                            </a>
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Email </v-row>
                          <v-row style="text-align: left">
                            {{ item.email ? item.email : '---' }}
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Contactable Type </v-row>
                          <v-row style="text-align: left">
                            {{
                              item.contactable_type
                                ? item.contactable_type
                                : '---'
                            }}
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row v-if="contacts.length == 0">
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <div class="mt-16 container justify-center item-center">
                        <img
                          style="height: 50px"
                          src="../../../assets/img/01.gif"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title producttiltle"
              ><v-icon color="blue" small>mdi-chart-pie</v-icon
              ><span class="ml-3"> Customer Related Factors</span>
            </v-card-title>
            <v-container fluid class="light gray lighten-12 saledetailscard">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                  <v-tabs horizontal background-color="primary" dark>
                    <v-tab> Sales </v-tab>
                    <v-tab-item>
                      <CustomerSalesList />
                    </v-tab-item>
                    <v-tab> Payments </v-tab>
                    <v-tab-item>
                      <CustomerPaymentList />
                    </v-tab-item>
                  </v-tabs>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title producttiltle"
              ><v-icon color="blue">mdi-content-paste</v-icon
              ><span class="ml-3">Recent Logs </span>
            </v-card-title>
            <v-container fluid class="light gray lighten-12 saledetailscard">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                  <AuditLogs :Type="'customers'" />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<!-- *************************************************************************
	SCRIPT
	************************************************************************* -->
<script>
//COMPONENTS
import CustomerHistory from './CustomerHistory';
import CustomerRewardPoint from './CustomerRewardPoint';
import CustomerLoyalty from './CustomerLoyalty';
import CustomerPaymentList from './CustomerPaymentList';
import CustomerSalesList from './CustomerSalesList';
export default {
  data() {
    return {
      name: '',
      code: '',
      reference_number: '',
      image: '',
      addresses: '',
      contacts: '',
      maximum_credit_amount: '',
      payment_team: '',
      customerType: '',
      grand_total: '',
      paid_amount: '',
      status: '',
    };
  },

  components: {
    CustomerHistory,
    CustomerRewardPoint,
    CustomerLoyalty,
    CustomerPaymentList,
    CustomerSalesList,
  },
  methods: {
    getSaleTypeColor(saletype) {
      switch (saletype) {
        case 'cash':
          return 'green';
          break;
        case 'Credit':
          return 'red';
          break;
        default:
          break;
      }
    },
    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },
    GetCustomer() {
      let customerId = this.$route.params.id;
      this.$store
        .dispatch('customer/GetCustomer', customerId)
        .then((item) => {
          this.name = item.data.name ? item.data.name : '----';
          this.code = item.data.code ? item.data.code : '----';
          this.reference_number = item.data.reference_number
            ? item.data.reference_number
            : '----';
          this.addresses = item.data.addresses ? item.data.addresses : '----';
          this.contacts = item.data.contact;
          this.image = item.data.image;
          this.status = item.data.is_active;
          this.maximum_credit_amount = item.data.maximum_credit_amount
            ? item.data.maximum_credit_amount
            : '------';
          this.customerType = item.data.customerType.name
            ? item.data.customerType.name
            : '----';
          this.payment_team = item.data.payment_team
            ? item.data.payment_team
            : '------';
          this.grand_total = item.data.grand_total ? item.data.grand_total : 0;
          this.paid_amount = item.data.paid_amount ? item.data.paid_amount : 0;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
  },
  created() {
    this.GetCustomer();
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
  margin-bottom: -16px;
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
</style>
